export default class AddCartResponse{
    Status;
    ResultRighe;
    Carrello;

    constructor(Status, ResultRighe, Carrello){
        this.Status = Status;       
        this.Carrello = Carrello;
    }
}